import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import IconLetters from '../icons/IconLetters.jsx'
import meta from './metaVr.mjs'
import Model from './ModelVr.mjs'
import PropertiesPane from './PropertiesPaneVr.jsx'
import FormChoose from './FormChooseVr.jsx'
import TableChoose from './TableChooseVr.jsx'
import api from './apiVr.mjs'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        getIcons() {
            return [
                <IconLetters
                    key="type"
                    fill={Color.DARK_GREEN}
                    letters="|||"
                    textColor="#fff"
                />
            ]
        },

        getTextPrefix(map, node) {
            const defaultPrefix = ProductNode.getTextPrefix.call(
                this, map, node
            )

            const {vsEnv} = node.data

            if (vsEnv) {
                return `${defaultPrefix}【${vsEnv}】`
            }
            else {
                return defaultPrefix
            }
        },

        _pushDataSlots: {
            depVsDeploys: [],
        },

        _getCategories(map, node) {
            return [
                'VR_DEPLOYED_IN',
                'VR_DEPLOYED_ON',
            ]
        },

        _getThemeColor(map, node) {
            return Color.DARK_GREEN
        },

        async _grow(map, node, depth) {
            const newDepth = await ProductNode._grow.call(
                this, map, node, depth
            )

            if (newDepth === depth) {
                return newDepth
            }

            const p = node.trueParent

            if (p) {
                const {bizNodeType} = p.data

                if ('CAT_ROOT_PRJ_DEP' === bizNodeType) {
                    for (const n of [...node.children]) {
                        if ('VR_DEPLOYED_ON' === n.data.bizNodeType) {
                            map.deleteNode(n)
                        }
                        else {
                            map.deleteTree(n)
                        }
                    }
                }
            }

            return newDepth
        },
    })
}
